(function () {
    'use strict';

    angular
        .module('core.services')
        .service('CompanyImageService', CompanyImageService)

    /** @ngInject */
    function CompanyImageService(HttpService) {
        const CompanyImageService = {
            post,
            put,
            deleteImage
        }

        return CompanyImageService;

        function post(companyImageData) {
            return HttpService.post('/companies/images', companyImageData);
        }

        function put(companyImageData) {
            return HttpService.put('/companies/images', companyImageData);
        }

        function deleteImage(companyImageId) {
            return HttpService.delete(`/companies/images/${companyImageId}`);
        }
    }
}());